import { jsx, Fragment } from "react/jsx-runtime";
function ConditionalWrapper({ wrapper, condition, children }) {
  return condition ? wrapper(children) : /* @__PURE__ */ jsx(Fragment, { children });
}
export {
  ConditionalWrapper as default
};
